import { render } from "./price_c.vue?vue&type=template&id=8191e07a&scoped=true"
import script from "./price_c.vue?vue&type=script&lang=js"
export * from "./price_c.vue?vue&type=script&lang=js"

import "./price_c.vue?vue&type=style&index=0&id=8191e07a&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8191e07a"]])

export default __exports__